export default "__VITE_ASSET__BO63TY2l__"